import { Grid, Typography } from '@mui/material'
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'


const columns = [
    { field: 'strategyDisplayName', headerName: 'Strategy', width: 200 },
    { field: 'usersCount', headerName: 'Users count', type: 'number', width: 100, align: 'center' },
    {
        field: 'users', headerName: 'Users', width: 700, valueFormatter: ({ value }) => value?.toString()?.replace(/,/g, ',   ')
    },
];

const StrategywiseUsers = ({ user }) => {
    const [strategywiseUsers, setStrategywiseUsers] = useState({})
    useEffect(() => {
        fetch(`/algo-trading/api/admin/strategywise-users`, {
            headers: new Headers({
                'Authorization': user?.credential
            }),
        }).then(r => {
            if (r.status >= 400) {
                return
            }
            r.json()
                .then(r => {
                    r?.forEach(strategyData => strategyData.usersCount = strategyData?.users?.length)
                    setStrategywiseUsers(r);
                })
        }
        ).catch(error => {
            console.log(error);
        })
    }, [user])

    return (
        <DataGrid
            slots={{
                toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
                    <Typography variant='h5' align='center'>Strategywise Users</Typography>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                    <GridToolbarExport />
                    <GridToolbarQuickFilter />
                </GridToolbarContainer>
            }}
            sx={{
                bgcolor: 'white',
                marginTop: 5
            }}
            getRowHeight={() => 'auto'}
            columns={columns}
            rows={strategywiseUsers || []}
            getRowId={row => row?.strategyDisplayName}
            initialState={{
                pagination: {
                    paginationModel: { page: 0, pageSize: 15 },
                },
            }}
            pageSizeOptions={[10, 20, 30, 40]}
            autoHeight={true}
        />
    )
}

export default StrategywiseUsers